import { render, staticRenderFns } from "./StudyNewPageFinished.vue?vue&type=template&id=1777f74e&scoped=true"
import script from "./StudyNewPageFinished.vue?vue&type=script&lang=js"
export * from "./StudyNewPageFinished.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageFinished.vue?vue&type=style&index=0&id=1777f74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1777f74e",
  null
  
)

export default component.exports